/**
 * UI-состояние (agents/web-shell.md §5).
 *
 * Только интерфейс: модалки, панели, черновики. Серверные данные живут
 * в TanStack Query и здесь не дублируются — это главный источник рассинхрона.
 */
import { create } from 'zustand';

interface UiState {
  mobileNavOpen: boolean;
  setMobileNavOpen: (open: boolean) => void;
  toggleMobileNav: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  mobileNavOpen: false,
  setMobileNavOpen: (open) => set({ mobileNavOpen: open }),
  toggleMobileNav: () => set((state) => ({ mobileNavOpen: !state.mobileNavOpen })),
}));
